// extracted by mini-css-extract-plugin
export default {"button":"styles_button__XdVSL","thin":"styles_thin__fbP52","bold":"styles_bold__Z+-ON"};